{
  "defaultAuthor": "Miembro de Xtreed",
  "errors": {
    "accessToken": "No se pudo generar el acceso.",
    "signIn": "No se pudo entrar en la comunidad.",
    "noResponse": "La comunidad no ha respondido."
  },
  "miniPlayer": {
    "size": "Tamaño del video",
    "sizeValue": "{{width}} píxeles de ancho",
    "position": "Posición del video — usa las flechas para moverlo",
    "lesson": "Clase",
    "backToLesson": "Volver a la clase"
  },
  "nav": {
    "loading": "Cargando espacios de la comunidad",
    "loadError": "No se pudieron cargar los espacios de la comunidad. Intenta recargar la página.",
    "empty": "Por ahora no hay ningún espacio disponible para ti.",
    "label": "Espacios de la comunidad",
    "postCount_one": "{{count}} publicación",
    "postCount_zero": "{{count}} publicaciones",
    "postCount_other": "{{count}} publicaciones",
    "lessonTag": "Clase",
    "locked": "Espacio bloqueado"
  },
  "list": {
    "pinned": "Fijado",
    "special": {
      "lockedTitle": "Espacio restringido",
      "calendarTitle": "Espacio de agenda",
      "materialsTitle": "Espacio de materiales",
      "lockedDescription": "Todavía no tienes acceso a este espacio. Debes abrirlo en la comunidad.",
      "unsupportedDescription": "Este tipo de espacio no se abre dentro de la clase — abre la comunidad para ver el contenido completo."
    },
    "empty": {
      "title": "Todavía no hay conversaciones aquí",
      "description": "Empieza tú: publica tu duda sobre la clase o enseña lo que acabas de crear."
    },
    "unavailable": "Espacio no disponible.",
    "postFooter": "_Publicado desde la clase [{{title}}]({{url}})._",
    "published": "¡Publicado!",
    "conversations_one": "{{count}} conversación",
    "conversations_zero": "{{count}} conversaciones",
    "conversations_other": "{{count}} conversaciones",
    "compose": {
      "titlePlaceholder": "Título de la publicación",
      "bodyPlaceholder": "Cuenta qué está pasando, pega el código, describe el error...",
      "cancel": "Cancelar",
      "publish": "Publicar",
      "publishIn": "Publicar en {{space}}"
    }
  },
  "conversation": {
    "removedAuthor": "Eliminado",
    "replied": "¡Respondido!",
    "none": {
      "title": "Ninguna conversación abierta",
      "description": "Elige una conversación de la lista para leer el hilo completo y responder desde aquí."
    },
    "loadError": {
      "title": "No se pudo cargar esta conversación",
      "description": "Puede ser una caída momentánea de la comunidad. Intenta abrirla de nuevo en unos instantes."
    },
    "reactWith": "Reaccionar con {{emoji}}",
    "replies": "Respuestas",
    "noReplies": "Nadie ha respondido todavía. Tu respuesta puede ser la primera.",
    "yourReply": "Tu respuesta",
    "replyPlaceholder": "Escribe tu respuesta…",
    "markdownHint": "Aquí puedes usar Markdown sencillo.",
    "reply": "Responder",
    "closed": "Esta conversación no admite nuevas respuestas."
  },
  "dock": {
    "community": "Comunidad",
    "someone": "Alguien",
    "replies_one": "{{count}} respuesta",
    "replies_zero": "{{count}} respuestas",
    "replies_other": "{{count}} respuestas",
    "openPrompt": "Ábrela para hablar con tus compañeros",
    "label": "Comunidad Xtreed",
    "back": "Volver",
    "showSpaces": "Ver espacios de la comunidad",
    "openFull": "Abrir completa",
    "backToLesson": "Volver a la clase",
    "spaces": "Espacios",
    "closeSpaces": "Cerrar espacios"
  }
}
